import { defineEntity, number, string, dateTime, object } from '~/prix'
import sql from '~/prix/utils/sql'

const monitorProductMetricIdsImportEntity = defineEntity({
  key: 'productMetricIds',
  title: 'Métricas de Produtos',
  sources: ['olap', 'oltp'],
  schema: object({
    id: number().label('ID').isOptional(),

    productCode: string().label('Código do produto'),
    productName: string().label('Nome do produto'),
    cluster: string().label('Cluster'),
    portfolio: string().label('Portfólio'),
    sebraeResponsavel: string().label('SEBRAE Responsável'),
    productActiveInactive: string().label('Produto ativo/inativo'),
    instantFixedPortfolio: string().label('Portfólio fixo/instantâneo'),
    instrument: string().label('Instrumento'),
    modality: string().label('Modalidade'),
    activationDate: dateTime().label('Data de habilitação'),

    productAgeInMonths: number().label('Idade do produto (meses)'),
    attendanceLast3Months: number().label('Atendimentos nos últimos 3 meses'),
    attendanceLast12Months: number().label('Atendimentos nos últimos 12 meses'),
    attendanceLast36Months: number().label('Atendimentos nos últimos 36 meses'),

    classesLast3Months: number().label('Turmas nos últimos 3 meses'),
    classesLast12Months: number().label('Turmas nos últimos 12 meses'),
    classesLast36Months: number().label('Turmas nos últimos 36 meses'),

    dateOfLastService: dateTime().label('Data do último atendimento'),
    daysSinceLastAppointment: number().label('Dias do último atendimento'),
    monthsWithServiceLast12: number().label('Meses com atendimento nos últimos 12 meses'),
    scopeLast12Months: number().label('Abrangência nos últimos 12 meses'),

    courseLifeCycleScore: number().label('Nota do ciclo de vida'),
    completionRate: number().label('Taxa de conclusão'),
    indexNps: number().label('NPS'),
    indexIds: number().label('IDS'),

    classificationBcg: string().label('Classificação BCG'),
    uf: string().label('UF'),

    createdAt: dateTime().label('Criado em'),
  }),
})

export const monitorProductMetricIdsImportEntityPropertyMap = {
  id: sql`product_metric_ids.id`,

  productCode: sql`product_metric_ids.product_code`,
  productName: sql`product_metric_ids.product_name`,
  cluster: sql`product_metric_ids.cluster`,
  portfolio: sql`product_metric_ids.portfolio`,
  sebraeResponsavel: sql`product_metric_ids.sebrae_responsavel`,
  productActiveInactive: sql`product_metric_ids.product_active_inactive`,
  instantFixedPortfolio: sql`product_metric_ids.instant_fixed_portfolio`,
  instrument: sql`product_metric_ids.instrument`,
  modality: sql`product_metric_ids.modality`,
  activationDate: sql`product_metric_ids.activation_date`,
  productAgeInMonths: sql`product_metric_ids.product_age_in_months`,
  attendanceLast3Months: sql`product_metric_ids.attendance_last_3_months`,
  attendanceLast12Months: sql`product_metric_ids.attendance_last_12_months`,
  attendanceLast36Months: sql`product_metric_ids.attendance_last_36_months`,
  classesLast3Months: sql`product_metric_ids.classes_last_3_months`,
  classesLast12Months: sql`product_metric_ids.classes_last_12_months`,
  classesLast36Months: sql`product_metric_ids.classes_last_36_months`,
  dateOfLastService: sql`product_metric_ids.date_of_last_service`,
  daysSinceLastAppointment: sql`product_metric_ids.days_since_last_appointment`,
  monthsWithServiceLast12: sql`product_metric_ids.months_with_service_last_12`,
  scopeLast12Months: sql`product_metric_ids.scope_last_12_months`,
  courseLifeCycleScore: sql`product_metric_ids.course_life_cycle_score`,
  completionRate: sql`product_metric_ids.completion_rate`,
  indexNps: sql`product_metric_ids.index_nps`,
  indexIds: sql`product_metric_ids.index_ids`,
  classificationBcg: sql`product_metric_ids.classification_bcg`,
  uf: sql`product_metric_ids.uf`,
  createdAt: sql`product_metric_ids.created_at`,
}

export default monitorProductMetricIdsImportEntity
